<template>
  <NuxtLayout>
    <article>
      <div class="container">
        <section class="error-content content-block-mid">
          <RichtextRichText :content="RTE_ERROR" />
          <div>
            <ul>
              <li v-for="page in sitemap" :key="page.link">
                <NuxtLink :to="page.link">{{ page.label }}</NuxtLink>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </article>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps<{ error: NuxtError }>();

const RTE_ERROR = 'Onverwachte fout opgetreden.';

/** TODO: Should be retrieved from getSetup function.
 *  Only send the sitemap properties to the errorPage (on createError).
 */
const sitemap = [
  { link: '/', label: 'Homepagina' },
  { link: '/', label: 'Vacatures' },
  { link: '/', label: 'Stages' },
  { link: '/', label: 'Over VECOZO' },
  { link: '/', label: "Onze-collega's" },
  { link: '/', label: 'Ons aanbod' },
  { link: '/', label: 'Mijn sollicitatie' },
];
</script>

<style lang="scss" scoped>
.error-content {
  grid-row: 2 / 3;

  :deep(p) {
    margin-bottom: px(30);
  }

  li {
    position: relative;
    padding-left: px(24);

    &::before {
      content: '•';
      display: block;
      position: absolute;
      font-size: px(24);
      font-weight: bold;
      left: 0;
      top: 0;
      line-height: px(24);
    }
  }
}
</style>
